export const ENDPOINTS = {
  get_user: "account/user/",
  update_user: "account/user/update/",
  update_password: "auth/password-update/",
};